export default __webpack_public_path__ + "static/media/66.54f97bce.png";